import { HealthSystemApi } from '../api/HealthSystemApi';
import BaseService from './BaseService';

export interface ProjectedSlaughterDateResponse {
  animalId: string;
  projectedSlaughterDate: string;
  isEstimated: boolean;
  modelVersion: string;
}

export interface LifecyclePredictionResponse {
  animalId: string;
  modelVersion: string;
  createdAt: string;
  birth: { phase: string; date: string; weightKg: number; isEstimated: boolean; isPast: boolean; isActual: boolean };
  weaned: { phase: string; date: string; weightKg: number; isEstimated: boolean; isPast: boolean; isActual: boolean };
  tenWeeks: { phase: string; date: string; weightKg: number; isEstimated: boolean; isPast: boolean; isActual: boolean };
  slaughterReady: {
    phase: string;
    date: string;
    weightKg: number;
    isEstimated: boolean;
    isPast: boolean;
    isActual: boolean;
  };
  readinessScore: number;
  daysToSlaughter: number | null;
  currentWeightKg: number;
  targetWeightKg: number;
  currentADGKgPerDay: number;
  antibioticImpact: {
    hasActiveWithdrawal: boolean;
    latestClearanceDate: string | null;
    delayDays: number;
    activeWithdrawals: Array<{
      supplyName: string;
      injectionDate: string;
      waitingTimeDays: number;
      clearanceDate: string;
      isCleared: boolean;
    }>;
  };
  growthCurve: Array<{ date: string; weightKg: number; isActual: boolean }>;
  dataPointsUsed: number;
  confidenceLevel: string;
  predictionTier: string;
  dataCompleteness: string;
  baselineProfile: string;
  fitSource: string;
  warnings: string[];
  modifiersApplied: string[];
}

export class ApiService extends BaseService {
  public api: HealthSystemApi<any>;

  constructor() {
    super();

    // Install the interceptor early so all requests are covered
    this.installGlobalFetchInterceptor();

    // Create the API instance - global wrapper covers all fetch calls
    this.api = new HealthSystemApi({
      baseUrl: this.apiUrl,
      baseApiParams: {
        headers: this.BuildRequestHeaders(true)
      }
    });
  }

  async getLifecyclePrediction(animalId: string): Promise<LifecyclePredictionResponse> {
    const res = await this.Fetch(`/animals/${animalId}/lifecycle-prediction`, 'GET');
    return this.FromResult<LifecyclePredictionResponse>(res);
  }

  async getProjectedSlaughterDate(animalId: string): Promise<ProjectedSlaughterDateResponse> {
    const res = await this.Fetch(`/animals/${animalId}/projected-slaughter-date`, 'GET');
    return this.FromResult<ProjectedSlaughterDateResponse>(res);
  }
}

export default ApiService;
